/**
 * @generated SignedSource<<878d9e809e1154339e47479668392eb7>>
 * @relayHash 989fc59544772ef57db4b2590fef7d4f
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 989fc59544772ef57db4b2590fef7d4f

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "file"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "src"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "file",
        "variableName": "file"
      },
      {
        "kind": "Variable",
        "name": "src",
        "variableName": "src"
      }
    ],
    "concreteType": "UpdateCommercialCodesMutationResponse",
    "kind": "LinkedField",
    "name": "updateCommercialCodes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "usersNotFound",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateCommercialCodesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateCommercialCodesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "989fc59544772ef57db4b2590fef7d4f",
    "metadata": {},
    "name": "UpdateCommercialCodesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "6c3619559145e16331b21baacabd056f";

export default node;
